// extracted by mini-css-extract-plugin
export default {"brandPromo":"sH-z","carousel":"tH-z"};